<template>

	<div>
		<app-boards board-key="company"></app-boards>
	</div>

</template>

<script>


import AppBoards from "@/components/boards/appBoards";
export default {
	name: "open",
	components: {AppBoards}
}
</script>

<style scoped>

</style>